import 'global.css';

import Fab from '@mui/material/Fab';

import { useScrollToTop } from 'hooks/use-scroll-to-top';

import { ThemeProvider } from 'theme/theme-provider';

import { Iconify } from 'components/iconify';
import ApiProvider from 'api/ApiProvider';
import AuthProvider from 'components/authentication/context/authContext';
import BerpRoutes from 'components/common/routes/BerpRoutes';
import LocaleProvider from 'components/i18n/LocaleProvider';
import LayoutProvider from 'components/Layout/LayoutProvider';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import QueryProvider from 'store/QueryProvider';
import { WebSocketProvider } from 'websocket';

// ----------------------------------------------------------------------

export default function App() {
  useScrollToTop();

  const githubButton = (
    <Fab
      size="medium"
      aria-label="Github"
      href="https://github.com/minimal-ui-kit/material-kit-react"
      sx={{
        zIndex: 9,
        right: 20,
        bottom: 20,
        width: 44,
        height: 44,
        position: 'fixed',
        bgcolor: 'grey.800',
        color: 'common.white',
      }}
    >
      <Iconify width={24} icon="eva:github-fill" />
    </Fab>
  );

  return (
    <QueryProvider>
      <ThemeProvider>
        <ErrorBoundary>
          <LayoutProvider>
            <ApiProvider>
              <AuthProvider>
                <LocaleProvider>
                  <WebSocketProvider>
                    <BerpRoutes />
                  </WebSocketProvider>
                </LocaleProvider>
              </AuthProvider>
            </ApiProvider>
          </LayoutProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </QueryProvider>
  );
}
